<template>
  <div class="container">
    <el-form :inline="true" :model="formInline" class="demo-form-inline margin-top-20">
      <el-form-item label="Name">
        <el-input v-model="formInline.name" placeholder="Name" clearable />
      </el-form-item>
      <el-form-item label="Problem Type">
        <el-select v-model="formInline.businessType" class="w-175" placeholder="Problem Type" clearable>
          <el-option label="Pricing" value="Pricing" />
          <el-option label="Answers" value="Answers" />
          <el-option label="Both" value="Pricing And Answers" />
        </el-select>
      </el-form-item>
      <el-form-item label="Contact">
        <el-select v-model="formInline.contactMethod" class="w-175" placeholder="Contact" clearable>
          <el-option label="Phone" value="Phone" />
          <el-option label="Email" value="Email" />
          <el-option label="Both" value="Phone And Email" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" :max-height="dynamicHeight" :highlight-current-row="true" header-cell-class-name="table-header-style" cell-class-name="padding-10-10" class="border-radius-6 margin-top-20 border"
      style="width: 100%;border-bottom: none;">
      <el-table-column prop="name" label="Name" />
      <el-table-column prop="email" label="Email" />
      <el-table-column prop="shopName" label="Shop" />
      <el-table-column prop="phone" label="Phone" />
      <el-table-column prop="businessType" label="Problem Type" />
      <el-table-column prop="contactMethod" label="Contact" />
      <el-table-column prop="description" label="Description" min-width="100">
        <template #default="scope">
          <el-popover placement="top-start" :title="`${scope.row.name} Description`" :width="300" trigger="hover"
            :content="scope.row.description">
            <template #reference>
              <span class="ellipsis-fallback">
                {{ scope.row.description }}
              </span>
            </template>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="Create Time" />
    </el-table>
    <div class="margin-top-20" style="float: right;">
      <el-pagination v-model:current-page="currentPage" :page-size="pageSize" :total="pageTotal"
        :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange" @current-change="handleCurrentChange" background
        layout="total, sizes, prev, pager, next," />
    </div>
  </div>
</template>
<script>
import { ElForm, ElFormItem, ElButton, ElTable, ElTableColumn, ElInput, ElPagination, ElSelect, ElOption, ElPopover } from "element-plus";
import DynamicHeightMixin from "../../../public/js/dynamicHeightMixin";
import { getShopifyServerList } from "@/utils/api";
export default {
  name: "shopifyOrder",
  mixins: [DynamicHeightMixin],
  components: { ElForm, ElFormItem, ElButton, ElTable, ElInput, ElPagination, ElSelect, ElOption, ElPopover, ElTableColumn },
  data() {
    return {
      dialogVisible: false,
      formInline: {
        name: '',
        contactMethod: '',
        businessType: '',
      },
      tableData: [],
      currentPage: 1,
      pageTotal: 0,
      pageSize: 20,
    }
  },
  methods: {
    onSubmit() {
      getShopifyServerList(this.currentPage, this.pageSize, this.formInline).then(res => {
        this.tableData = res.data.data
        this.currentPage = res.data.currentPage
        this.pageSize = res.data.pageSize
        this.pageTotal = res.data.total
      }).catch(err => console.error('数据处理错误:', err));
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.onSubmit();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onSubmit();
    },
  },
  created() {
    this.onSubmit()
  }
}
</script>
<style scoped>
.container {
  width: 92%;
  margin: 0 auto;
}

::v-deep .container {
  .el-form-item {
    margin-bottom: 0 !important;
  }
}

::v-deep .el-table .el-table__cell {
  box-sizing: border-box;
  min-width: 0;
  padding: 8px 0;
  position: relative;
  text-align: left;
  text-overflow: ellipsis;
  vertical-align: middle;
  z-index: unset !important;
}

.w-175 {
  width: 175px !important;
}

.pagination {
  margin: 20px auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ellipsis-fallback {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
}
</style>